import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { OrganizationDetailsForm } from '../components';
import { useOrganization } from '../../organization/hooks/useOrganization';

import { H1, CenteredLayout } from '../../../components';

const StyledH1 = styled(H1)`
  margin: 10px auto 40px;
`;

const Organization = () => {
  const navigate = useNavigate();
  const { onSubmit, onSkip, handleCreateOrganization } = useOrganization(navigate);
  return (
    <CenteredLayout>
      <StyledH1>Add your organization details</StyledH1>
      <OrganizationDetailsForm
        onSubmit={onSubmit}
        handleSubmit={handleCreateOrganization}
        onSkip={onSkip}
      />
    </CenteredLayout>
  );
};

export { Organization };
